import * as React from "react";
import type { SVGProps } from "react";
const SvgHeartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M15.71.79A5.8 5.8 0 0 0 13.85.5 6.26 6.26 0 0 0 10 1.8c-.09-.07-.2-.13-.3-.19s-.28-.21-.43-.29l-.38-.17c-.2-.11-.41-.19-.63-.26a.4.4 0 0 0-.09-.06h-.06A6.2 6.2 0 0 0 6.28.5h-.11q-.42 0-.84.06h-.12a4.5 4.5 0 0 0-.89.21C.59 1.99-.74 6.04.39 9.58a12.9 12.9 0 0 0 3.01 4.8 38 38 0 0 0 6.37 4.96l.26.16.25-.15c2.28-1.43 4.4-3.09 6.33-4.96 1.35-1.35 2.38-3 3.01-4.81 1.11-3.54-.22-7.59-3.91-8.79" />
  </svg>
);
export default SvgHeartIcon;
